import axios from 'axios';

const http = axios.create({
  baseURL: 'localhost:8000/api',
  timeout: 60000,
});

export default http;